import Vue from 'vue';

const PmEventBus = new Vue();

export { PmEventBus };
